import router from "../router/routers"
import store from "../vuex/AppStore"
import Constant from "../constant/config"
import table from "../utils/ServiceTable"


class BluetoothRepository {
    _cacheServices = {}
    _decoder       = new TextDecoder()
    _server        = null
    device         = null

    constructor() {
        //监听设备的连接状态
        if (navigator.bluetooth && navigator.bluetooth.addEventListener) {
            navigator.bluetooth.addEventListener("availabilitychanged", e => {
                // if (e) {
                //     router.push("Home")
                // }
            })
        }
    }

    async scanDevice(filter) {
        const {acceptAllDevices, filterCondition} = filter
        this.disconnect()

        let filterParams = []
        if (filterCondition) {
            const service = filterCondition.filterService
            if (service) {
                filterParams.push({services: [service]})
            }

            const namePrefix = filterCondition.prefixDeviceName && filterCondition.prefixDeviceName.split(",")
            namePrefix && namePrefix.forEach(item => {
                filterParams.push({namePrefix: item})
            })

            const name = filterCondition.filterDeviceName && filterCondition.filterDeviceName.split(",")
            name && name.forEach(item => {
                filterParams.push({name: item})
            })
        }


        let requestParams = {}
        if (acceptAllDevices) {
            requestParams.acceptAllDevices = acceptAllDevices
        } else {
            requestParams.filters = filterParams
        }

        let device = await navigator.bluetooth.requestDevice(requestParams);

        this.device = device

        //监听设备的连接状态
        device.addEventListener("gattserverdisconnected", e => {
            router.push('Home')
        })

        this._server = await device.gatt.connect()


        const services = await this._server.getPrimaryServices()
        for (let i = 0; i < services.length; i++) {
            const service                     = services[i]
            const characteristics             = await service.getCharacteristics()
            this._cacheServices[service.uuid] = characteristics
            for (let j = 0; j < characteristics.length; j++) {
                const characteristic     = characteristics[j]
                characteristic.aliasName = table.findCharacteristicName(characteristic.uuid)
                if (characteristic.properties === (characteristic.properties | Constant.PeripheralProperties.read)) {
                    const readData      = await this.read(service.uuid, characteristic.uuid)
                    characteristic.data = readData
                    console.log(`读取的数据${readData} `)
                } else if (characteristic.properties === (characteristic.properties | Constant.PeripheralProperties.notify)) {
                    await this.notify(service.uuid, characteristic.uuid)
                }
                characteristic.propertiesString = this.toPropertiesDesc(characteristic.properties)
            }
        }


        store.commit("peripheralInfo", this._cacheServices)
        store.commit("deviceInfo", {name: device.name, id: device.id})

        router.replace({name: 'PeripheralDetail'})
        console.log("连接成功")
    }


    toPropertiesDesc(properties) {
        let propertiesDesc = []
        Constant.PeripheralPropertiesMap.forEach((item, index) => {
            console.log(`item properties = ${properties}  item = ${item}`)
            if (properties === (item | properties)) {
                switch (item) {
                    case Constant.PeripheralProperties.broadcast:
                        propertiesDesc.push("Broadcast")
                        break
                    case Constant.PeripheralProperties.read:
                        propertiesDesc.push("Read")
                        break
                    case Constant.PeripheralProperties.writeWithoutResponse:
                        propertiesDesc.push("WriteWithoutResponse")
                        break
                    case Constant.PeripheralProperties.write:
                        propertiesDesc.push("Write")
                        break
                    case Constant.PeripheralProperties.notify:
                        propertiesDesc.push("Notify")
                        break
                    case Constant.PeripheralProperties.indicate:
                        propertiesDesc.push("Indicate")
                        break
                    case Constant.PeripheralProperties.authenticatedSignedWrites:
                        propertiesDesc.push("Authenticated Signed Writes")
                        break
                    case Constant.PeripheralProperties.extendedProperties:
                        propertiesDesc.push("Extended Properties")
                        break
                    case Constant.PeripheralProperties.notifyEncryptionRequired:
                        propertiesDesc.push("Notify Encryption Required")
                        break
                    case Constant.PeripheralProperties.indicateEncryptionRequired:
                        propertiesDesc.push("Indicate Encryption Required")
                        break
                    default:
                }

            }
        })
        return propertiesDesc.join(",")
    }

    async read(serviceUUID, characteristicUUID) {
        const cacheService = this._cacheServices[serviceUUID]
        const target       = cacheService.find(item => item.uuid === characteristicUUID && item.service.uuid === serviceUUID)
        if (target.properties !== (Constant.PeripheralProperties.read | target.properties)) {
            return null
        }

        const service           = await this._server.getPrimaryService(serviceUUID)
        const characteristic    = await service.getCharacteristic(characteristicUUID)
        const readData          = await characteristic.readValue()
        const isConvertToString = target.aliasName.toLowerCase().indexOf("string") !== -1
        if (isConvertToString) {
            return this._decoder.decode(readData.buffer)
        }

        const hex = Buffer.from(readData.buffer).toString('hex').toUpperCase()
        return `Length:${hex.length}\nData:0x${hex}`
    }

    async write(serviceUUID, characteristicUUID, data) {
        const cacheService = this._cacheServices[serviceUUID]
        const target       = cacheService.find(item => item.uuid === characteristicUUID && item.service.uuid === serviceUUID)
        if (target.properties !== (Constant.PeripheralProperties.write | target.properties)) {
            return null
        }

        const service        = await this._server.getPrimaryService(serviceUUID)
        const characteristic = await service.getCharacteristic(characteristicUUID)
        await characteristic.writeValue(data)
        return true
    }

    async notify(serviceUUID, characteristicUUID) {
        const cacheService = this._cacheServices[serviceUUID]
        const target       = cacheService.find(item => item.uuid === characteristicUUID && item.service.uuid === serviceUUID)
        if (target.properties !== (target.properties | Constant.PeripheralProperties.notify)) {
            return null
        }
        const service        = await this._server.getPrimaryService(serviceUUID)
        const characteristic = await service.getCharacteristic(characteristicUUID)
        await characteristic.startNotifications()
        characteristic.addEventListener("characteristicvaluechanged", event => {
            const c                    = event.target
            const data                 = c.value
            const serviceUUID          = c.service.uuid
            const notifyData           = {}
            const characteristicData   = {}
            characteristicData[c.uuid] = data
            notifyData[serviceUUID]    = characteristicData
            console.log(`Received->\nServiceUUID:${c.service.uuid}\nCharacteristicUUID:${c.uuid}\nData:0x${Buffer.from(data.buffer).toString('hex')}`)
            store.commit("notifyDataChanged", notifyData)
        })
    }

    disconnect() {
        if (this._server) {
            this._server.disconnect()
            this.device = null
        }
    }

}

const DEVICE_READ_SERVICE_UUID = "0000180a-0000-1000-8000-00805f9b34fb"
const bluetoothRepository      = new BluetoothRepository()
export default bluetoothRepository